// src/pages/News.js
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import "../App.css";
import { Link } from "react-router-dom";

const News = () => {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      const q = query(collection(db, "news"), orderBy("date", "desc"));
      const snapshot = await getDocs(q);
      const news = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        date: doc.data().date?.toDate() || null, // Convert Firestore Timestamp to JS Date
      }));
      setNewsData(news);
    };
    fetchNews();
  }, []);

  return (
    <section className="news_page">
      <h2><span>News</span> & Updates</h2>
      <div className="news_grid">
        {newsData.map((item) => (
          <Link to={`/news/${item.id}`} className="news_card" key={item.id}>
          <img src={item.image} alt={item.title} className="news_image" />
          <div className="news_content">
            <h4>{item.title}</h4>
            <small className="news_date">
              {item.date ? item.date.toLocaleDateString("en-NZ", {
                year: "numeric",
                month: "long",
                day: "numeric"
              }) : "No date"}
            </small>
            <p>{item.desc.slice(0, 100)}...</p>
            <span className="read_more">Read more →</span>
          </div>
        </Link>
        ))}
      </div>
    </section>
  );
};

export default News;
